import { Alert, Input, message, Skeleton, Space } from 'antd';
import Form, { FormInstance } from 'antd/lib/form';
import FormItem, { FormItemProps } from 'antd/lib/form/FormItem';
import * as React from 'react';
import APITokenUsersApiService from '../../api/APITokenUsersApiService';
import FeatureFlag from '../../consts/FeatureFlag';
import * as CreateAPITokenUserHandler from '../../handlerModels/CreateAPITokenUserHandler';
import BaseFormProps from '../../redux/bases/BaseFormProps';
import BaseFormState from '../../redux/bases/BaseFormState';
import FormUtil from '../../utils/FormUtil';
import ValidationRuleUtil from '../../utils/ValidationRuleUtil';
import ValidationUtil from '../../utils/ValidationUtil';
import AuthorizedContent from '../AuthorizedContent';
import SaveButton from '../buttons/SaveButton';

interface AddAPITokenUserFormState extends BaseFormState {
}

interface AddAPITokenUserFormProps extends BaseFormProps {
  onSuccess?: () => void;
}

class AddAPITokenUserForm extends React.Component<AddAPITokenUserFormProps, AddAPITokenUserFormState> {
  private readonly _formRef = React.createRef<FormInstance>();
  private readonly _formItems = new Map<string, FormItemProps>()
    .set(CreateAPITokenUserHandler.Request.userName, {
      required: true,
      name: CreateAPITokenUserHandler.Request.userName,
      label: 'API Name',
      rules: [
        ValidationRuleUtil.required()
      ],
    });

  constructor(props: AddAPITokenUserFormProps) {
    super(props);

    this.state = {
    };
  }

  public submit = () => {
    this.handleSubmit();
  }

  public reset = () => {
    this._formRef.current?.resetFields();
  }

  private handleChange = () => {
    this.setState({ altered: true });
  }

  private handleSubmit = () => {
    this.setState({ submitting: true });

    const request = CreateAPITokenUserHandler.Request.create(this._formRef ? (this._formRef.current as any).getFieldsValue() : null);

    APITokenUsersApiService.addAPITokenUser(request)
      .then((result: CreateAPITokenUserHandler.Result) => {
        this.setState({
          submitted: true
        });

        if (result?.succeeded) {
          message.success('Added! The secret is, ' +  result?.secret + ' and key is ' + result?.user.apiKey);

          if (this.props.onSuccess) {
            this.props.onSuccess();
          }

          this._formRef.current?.resetFields();

          this.setState({ altered: false });

          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
        }
        else {
          this.setState({
            error: !result?.succeeded,
            message: result?.errors.join('\n'),
            fieldErrors: result?.fieldErrors
          });
          message.error('Error Adding User');
        }
      })
      .catch((results: any) => {
        this.setState({ error: results });
        message.error('Error Adding User');
      })
      .finally(() => {
        this.setState({ loading: false, submitting: false });
      });
  }

  render() {
    if (this.state.loading) {
      return <Skeleton active={true} />;
    }

    return (
      <Space size="small" direction="vertical">
        <Form
          ref={this._formRef}
          layout="vertical"
          onValuesChange={this.handleChange}
          onFinish={this.handleSubmit} requiredMark={true}>

          <FormItem
            {...this._formItems.get(CreateAPITokenUserHandler.Request.userName)}
            {...ValidationUtil.getValidation(CreateAPITokenUserHandler.Request.userName, this.state.fieldErrors, this.state.submitted)}>
            <Input disabled={this.state.loading || this.state.submitting} />
          </FormItem>

          {this.renderSave()}
        </Form>
      </Space >
    );
  }

  renderSave() {
    return (
      <AuthorizedContent validFeatureFlags={this.props.isNew ? [FeatureFlag.EDIT_CATEGORY] : [FeatureFlag.EDIT_CATEGORY]} >
        <Space direction={'horizontal'} >
          <SaveButton htmlType='submit' disabled={!FormUtil.canSubmit(this._formRef, this._formItems)} saving={this.state.submitting} hidden={true} />
        </Space>
      </AuthorizedContent>
    );
  }

  renderErrors() {
    if (this.state.error) {
      return <Alert type="error" message='Error' showIcon={true} description='There were errors submitting your request. Please review the fields below.' />;
    }
  }
}

export default AddAPITokenUserForm;
